import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { Dropdown } from '../..';
import ButtonV2 from '../button/ButtonV2';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/20/solid';

type PaginationProps = {
    total: number;
    rowLimits: number[];
    page: number;
    rowLimit: number;
    onPageChange: (page: number) => void;
    onRowLimitChange: (limit: number) => void;
    defaultRowSizeIndex?: number;
    limitDirection?: 'top' | 'bottom';
};

function rowsFrom(page: number, rowSize: number): number {
    const pageOffset = 1; // Pages start at index 1 not 0
    return (page - pageOffset) * rowSize + pageOffset;
}

function rowsTo(page: number, rowSize: number): number {
    return page * rowSize;
}

function Pagintation({ total, rowLimits, onPageChange, onRowLimitChange, page, rowLimit, limitDirection }: PaginationProps): JSX.Element {
    const [canNext, setCanNext] = useState(false);
    const [canPrevious, setCanPrevious] = useState(false);
    const [rowLimitDirection, setRowLimitDirection] = useState<'top' | 'bottom'>('top');
    const ref = useRef<HTMLDivElement>();

    useLayoutEffect(() => {
        if (ref.current) {
            const diff = window.innerHeight - ref.current.offsetTop;
            setRowLimitDirection(diff < 200 ? 'top' : 'bottom');
        }
    }, [ref.current?.offsetTop, window.innerHeight]);

    // Re-calculate if the user can click next or previous
    useEffect(() => {
        if (total === 0) {
            setCanNext(false);
            setCanPrevious(false);
        } else {
            setCanNext(page !== Math.ceil(total / rowLimit));
            setCanPrevious(page !== 1);
        }
    }, [total, page, rowLimit]);

    return (
        <div ref={ref} className="flex  flex-wrap gap-y-2 justify-between dark:text-white/[0.87] text-sm text-gray-700">
            <section className="flex items-center gap-2">
                <p>Rows per page:</p>
                <Dropdown label={rowLimit.toString()} type="secondary" direction={limitDirection || rowLimitDirection}>
                    {rowLimits.map((limit) => {
                        return (
                            <Dropdown.Option
                                key={limit}
                                label={limit.toString()}
                                value={limit}
                                onClick={(): void => {
                                    onRowLimitChange && onRowLimitChange(limit);
                                }}
                            />
                        );
                    })}
                </Dropdown>
            </section>
            <section className="flex gap-4 items-center">
                <p className="">
                    {total > 0 ? `Showing ${rowsFrom(page, rowLimit)} to ${rowsTo(page, rowLimit)} of ${total} items` : 'Showing 0 items'}
                </p>
                {(canNext || canPrevious) && total > 0 && (
                    <>
                        <span>
                            <ButtonV2
                                type="secondary"
                                // label="Previous"
                                onClick={(): void => onPageChange(page - 1)}
                                isDisabled={!canPrevious}
                                // size="sm"
                                leftIcon={<ChevronLeftIcon />}
                            />
                        </span>
                        <span>
                            <ButtonV2
                                type="secondary"
                                // label="Next"
                                onClick={(): void => onPageChange(page + 1)}
                                isDisabled={!canNext}
                                // size="sm"
                                leftIcon={<ChevronRightIcon />}
                            />
                        </span>
                    </>
                )}
            </section>
        </div>
    );
}

export default Pagintation;
